const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const withContainerDims = require("../core/hoc/withContainerDims");
const AT = require("../core/vault/ActionTypes");
const LoadState = require("../core/vault/util/LoadState");
const URLMake = require("../../shared/URLMake");
const Link = require("../core/view/Link");
const ReportCrumbs = require("./ReportCrumbs");
const ReportNavigationHeader = require("./ReportNavigationHeader");
const {
	atPage,
	atSchool,
	atClass,
	atClassLocks,
	atReportBookTestBlocks,
} = require("../core/vault/StateCursors");
const GraphTableHeading = require("./GraphTableHeading");
const MultiSlots = require("../core/vault/MultiSlots");
const MultiLoadGuard = require("../core/view/MultiLoadGuard");
const ReportTable = require("./ReportTable");
const ProfileUtil = require("../core/util/ProfileUtil");
const GradeChapter = require("../../shared/GradeChapter");
const ClassesUtil = require("./util/ClassesUtil");
const OfficeModal = require("../office/modals/OfficeModal");
const {PORTAL_CONTAINERS} = require("../../shared/PortalConstants");
const StarBar = require("./StarBar");
const OpsLab = require("../lab/vault/OpsLab");
const SummaryCircles = require("./SummaryCircles");
const ResultManager = require("../../shared/ResultManager");
const StringUtil = require("../../shared/StringUtil");
const ArrayUtil = require("../core/util/ArrayUtil");
const {shallowEqOnKeys} = require("../core/util/SCUUtil");
const HoverText = require("../core/view/HoverText");
const Helpers = require("./ReportTableHelpers");
const OpsSchool = require("./vault/OpsSchool");
const ReportTestUnlockPanel = require("./ReportTestUnlockPanel");
const CopyTable = require("./data/CopyTable");
const AssignedToggle = require("./AssignedToggle");
const OpsLockOverrides = require("../core/vault/OpsLockOverrides");

const styles = require("./styles/ReportMainBody.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withContainerDims(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			const {
				gradeNumber,
				chapterNumber,
				classID,
				blockNumber,
				bookTest,
				typeID,
			} = props;
			const allLockOverrides = _.get(vaultState, "lockOverrides", {});
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			const studentIDs = atClass(vaultState, classID).getIn("studentIDs");

			const schoolState = atSchool(vaultState).get();

			const thisClassesActiveStudentIDs = _.get(props.classesData, [
				classID,
				"activeStudentIDs",
			]);
			const allStudents = _.get(schoolState, ["accounts", "students"], {});
			const activeStudentsByID = _.pick(
				allStudents,
				thisClassesActiveStudentIDs
			);

			const typeIDs = OpsLab.getAllTypeIDs();
			return {
				allLockOverrides,
				forPrint: atPage(vaultState).get().forPrint,
				studentIDs,
				schoolState,
				showAssignedBlocksModal: atPage(vaultState).getIn(
					"assignedBlocksModal"
				),
				activeStudentsByID,
				// This object is loaded on the side with the book test results, so
				// it doesn't have a load guard.
				bookTestBlocksObj: atReportBookTestBlocks(vaultState).get(),
				blocksObjLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.chapterBlocks(),
					[chapterID]
				),
				blocksObj: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.chapterBlocks(),
					[chapterID]
				),
				assignedBlocksObjLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.assignedBlocks(),
					[classID]
				),
				assignedBlocksObj: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.assignedBlocks(),
					[classID]
				),
				labBlocksObjLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.labBlocks(),
					typeIDs
				),
				labBlocksObj: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.labBlocks(),
					typeIDs
				),
				lockOverrides:
					atClassLocks(vaultState, classID).get() || LoadState.loadInit(),
				classGradeChapterLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportGradeChapter(),
					studentIDs
				),
				classGradeChapter: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportGradeChapter(),
					studentIDs
				),
				classChapterBlockLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportChapterBlock(chapterID),
					studentIDs
				),
				classChapterBlock: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportChapterBlock(chapterID),
					studentIDs
				),
				classBlockResultsLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportBlockResults(chapterID, blockNumber),
					studentIDs
				),
				classBlockResults: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportBlockResults(chapterID, blockNumber),
					studentIDs
				),
				classBookTestResultsLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportBookTestResults(bookTest),
					studentIDs
				),
				classBookTestResults: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportBookTestResults(bookTest),
					studentIDs
				),
				classLabTypes: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportLabTypes(),
					studentIDs
				),
				classLabTypesLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportLabTypes(),
					studentIDs
				),
				classLabBlockResults: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportLabBlockResults(typeID),
					studentIDs
				),
				classLabBlockResultsLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportLabBlockResults(typeID),
					studentIDs
				),
			};
		},
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ReportClassBody",

		propTypes: {
			user: PT.object.isRequired,
			pageData: PT.object,
			classID: PT.number.isRequired,
			gradeNumber: PT.oneOfType([PT.string, PT.number]),
			chapterNumber: PT.oneOfType([PT.string, PT.number]),
			blockNumber: PT.oneOfType([PT.string, PT.number]),
			bookTest: PT.string,
			typeID: PT.oneOfType([PT.string, PT.number]),
			labBlockID: PT.oneOfType([PT.string, PT.number]),
			updateClassFilter: PT.func.isRequired,
			classesData: PT.object,
			activeStudentsByID: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			containerDims: PT.shape({
				windowWidth: PT.number,
			}).isRequired,
			lockOverrides: PT.object.isRequired,
			showAssignedBlocksModal: PT.object,
			// Has ALL lock overrides, including those
			// for individual students
			// Used to determine if a block can be assigned
			allLockOverrides: PT.object.isRequired,
			studentIDs: PT.array.isRequired,
			schoolState: PT.object.isRequired,
			bookTestBlocksObj: PT.object,
			blocksObj: PT.object.isRequired,
			blocksObjLoad: PT.object.isRequired,
			assignedBlocksObj: PT.object.isRequired,
			assignedBlocksObjLoad: PT.object.isRequired,
			labBlocksObj: PT.object.isRequired,
			labBlocksObjLoad: PT.object.isRequired,
			classGradeChapterLoad: PT.object.isRequired,
			classGradeChapter: PT.object.isRequired,
			classChapterBlockLoad: PT.object.isRequired,
			classChapterBlock: PT.object.isRequired,
			classBlockResultsLoad: PT.object.isRequired,
			classBlockResults: PT.object.isRequired,
			classBookTestResultsLoad: PT.object.isRequired,
			classBookTestResults: PT.object.isRequired,
			classLabTypesLoad: PT.object.isRequired,
			classLabTypes: PT.object.isRequired,
			classLabBlockResultsLoad: PT.object.isRequired,
			classLabBlockResults: PT.object.isRequired,
			forPrint: PT.bool,
		},

		shouldComponentUpdate: function(nextProps, nextState) {
			const p = [
				"classID",
				"gradeNumber",
				"chapterNumber",
				"blockNumber",
				"bookTest",
				"typeID",
				"labBlockID",
				"blocksObj",
				"classGradeChapter",
				"classChapterBlock",
				"lockOverrides",
				"containerDims",
			];
			return (
				!shallowEqOnKeys(this.props, nextProps, p) ||
				!_.isEqual(this.state, nextState)
			);
		},

		getInitialState: function() {
			return {toggleAssigned: false};
		},

		componentDidUpdate: function(prevProps) {
			const p = ["classID", "gradeNumber", "chapterNumber", "blockNumber"];
			if (!shallowEqOnKeys(this.props, prevProps, p)) {
				// eslint-disable-next-line react/no-did-update-set-state
				this.setState(this.getInitialState());
			}
		},

		filterBy: function(col, val) {
			this.props.updateClassFilter(col, val);
		},

		dismissAssignedBlockModal: function() {
			this.props.dispatch({
				type: AT.DISMISS_ASSIGNED_BLOCK_MODAL,
			});
		},

		loadBlocks: function() {
			const {gradeNumber, chapterNumber} = this.props;
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			this.props.dispatch({
				type: AT.LOAD_CHAPTER_BLOCKS_SLOT_REQUEST,
				chapterIDs: [chapterID],
			});
		},

		loadLockOverrides: function() {
			this.props.dispatch({
				type: AT.LOAD_LOCKS_REQUEST,
				classID: this.props.classID,
			});
		},

		loadGradeChapter: function() {
			this.props.dispatch({
				type: AT.LOAD_REPORT_GRADE_CHAPTER_SLOT_REQUEST,
				classID: this.props.classID,
			});
		},

		loadChapterBlock: function() {
			const {gradeNumber, chapterNumber, classID} = this.props;
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			this.props.dispatch({
				type: AT.LOAD_REPORT_CHAPTER_BLOCK_SLOT_REQUEST,
				classID,
				chapterID,
			});
		},

		loadBlockResults: function() {
			const {gradeNumber, chapterNumber, blockNumber, classID} = this.props;
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			this.props.dispatch({
				type: AT.LOAD_REPORT_BLOCK_RESULTS_SLOT_REQUEST,
				classID,
				chapterID,
				blockNumber,
			});
		},

		loadBookTestResults: function() {
			const {bookTest, classID} = this.props;
			this.props.dispatch({
				type: AT.LOAD_REPORT_BOOK_TEST_RESULTS_SLOT_REQUEST,
				classID,
				bookHash: bookTest,
			});
		},

		loadLabBlocks: function() {
			this.props.dispatch({
				type: AT.LOAD_TYPE_LAB_BLOCKS_SLOT_REQUEST,
				typeIDs: OpsLab.getAllTypeIDs(),
			});
		},

		loadLabTypes: function() {
			const {studentIDs} = this.props;
			this.props.dispatch({
				type: AT.LOAD_REPORT_LAB_TYPES_SLOT_REQUEST,
				studentIDs,
			});
		},

		loadLabBlockResults: function() {
			const {studentIDs, typeID} = this.props;
			this.props.dispatch({
				type: AT.LOAD_REPORT_LAB_BLOCK_RESULTS_SLOT_REQUEST,
				studentIDs,
				typeID,
			});
		},

		loadAssignedBlocks: function() {
			const classIDs = _.keys(
				_.get(this.props.schoolState, ["report", "classes"], {})
			);
			this.props.dispatch({
				type: AT.LOAD_ASSIGNED_BLOCKS_FOR_CLASS_REQUEST,
				classIDs,
			});
		},

		openResult: function({resultID, problemIndex, blockID, userID, isTrophy}) {
			if (resultID || blockID) {
				this.props.dispatch({
					type: AT.SHOW_REPORT_PROBLEM_MODAL,
					resultID,
					problemIndex,
					blockID,
					userID,
					isTrophy,
				});
			}
		},

		onUnlockBookTest: function() {
			const {classID, bookTest} = this.props;
			this.props.dispatch({
				type: AT.REPORT_UNLOCK_BOOK_TEST_REQUEST,
				classID,
				bookTest,
			});
		},

		getAssignedBlockDataForGrades: function({
			assignedBlocksObj,
			classID,
			isAcademy,
		}) {
			const {lockOverrides} = this.props;
			const allGrades = GradeChapter.getActiveGrades();
			// We are looking at all grades, so we need to see if anything is assigned
			// in any of the grades
			const res = allGrades.map(g => {
				const locks = OpsLockOverrides.getLockInfo(lockOverrides, "grade", g);
				const assignedForGrade = this.getAssignedBlockDataForChapters({
					assignedBlocksObj,
					classID,
					gradeNumber: g,
					isAcademy,
				});
				const areAnyAssigned = _.some(assignedForGrade, "disabled");
				return {
					disabled: areAnyAssigned && locks && !locks.lockOverride,
					disabledText:
						"Some lessons from this level are assigned. You cannot lock a level that includes assigned lessons.",
				};
			});
			return res;
		},

		getAssignedBlockDataForChapters: function({
			assignedBlocksObj,
			classID,
			gradeNumber,
			isAcademy,
		}) {
			if (!gradeNumber || !_.isNumber(gradeNumber)) return [];
			const assignedBlocksForThisClass = _.get(
				assignedBlocksObj,
				[classID],
				{}
			);
			// Since we are on the level view, we need to see if any blocks
			// are assigned in any of the chapters in this grade
			const {lockOverrides} = this.props;
			const {blocksInChapters} = lockOverrides;
			const chaptersInGrade = GradeChapter.getAllChaptersForGrade(gradeNumber);
			const res = chaptersInGrade.map(chapter => {
				const locks = OpsLockOverrides.getLockInfo(
					lockOverrides,
					"chapter",
					chapter
				);
				const blocks = _.get(blocksInChapters, [chapter]);
				const areAnyAssigned = _.some(blocks, b => {
					const block = assignedBlocksForThisClass[b];
					return block && block.isAssigned;
				});
				return {
					disabled: areAnyAssigned && locks && !locks.lockOverride,
					disabledText:
						"Some lessons from this chapter are assigned. You cannot lock a chapter that includes assigned lessons.",
				};
			});
			return res;
		},

		getAssignedBlockData: function({
			assignedBlocksObj,
			classID,
			blockData,
			isAcademy,
		}) {
			const assignedBlocksForThisClass = _.get(
				assignedBlocksObj,
				[classID],
				{}
			);
			const {lockOverrides, allLockOverrides, pageData} = this.props;
			const locksForBlocks = _.get(lockOverrides, ["lockData", "blocks"], {});

			const {grade, chapter} = pageData;
			const corrChapterNumber = GradeChapter.toChapterID(grade, chapter - 1);

			const isBlockLocked = blockID => {
				const lockInfoForBlock = locksForBlocks[blockID];
				if (!lockInfoForBlock) return false;
				if (lockInfoForBlock.classIDWithOverride !== classID) return false;
				return lockInfoForBlock.lockOverride === "locked";
			};

			const lockOverrideClassKey = `class${classID}`;
			const allClassLockOverrideData = _.get(
				allLockOverrides,
				[lockOverrideClassKey, "lockData"],
				{}
			);

			const allClassChapterLockData = allClassLockOverrideData["chapters"];
			const allClassGradeLockData = allClassLockOverrideData["grades"];

			const isThisGradeLockedForClass =
				_.get(allClassGradeLockData, [grade, "lockOverride"]) === "locked";
			const isThisChapterLockedForClass =
				_.get(allClassChapterLockData, [corrChapterNumber, "lockOverride"]) ===
				"locked";

			let disabledText = "You must unlock this lesson before assigning it.";

			// Normally we would only assign one of these, but the grade/level lock message
			// should take priority over telling the teacher the chapter is locked
			// because if the level is locked then every chapter is effectively locked
			if (isThisChapterLockedForClass) {
				disabledText =
					"The chapter must first be unlocked to assign this lesson.";
			}

			if (isThisGradeLockedForClass) {
				disabledText =
					"The level must first be unlocked to assign this lesson.";
			}

			const assignedBlockData = _.map(blockData, b => {
				const thisAssignedBlock = assignedBlocksForThisClass[b.id];
				if (isAcademy && !thisAssignedBlock) return {};
				const isLocked =
					isThisChapterLockedForClass ||
					isThisGradeLockedForClass ||
					isBlockLocked(b.id);
				const isAssigned = thisAssignedBlock && thisAssignedBlock.isAssigned;

				return {
					blockID: b.id,
					isAssigned: !!_.get(assignedBlocksForThisClass, [b.id, "isAssigned"]),
					isReleased: _.get(
						assignedBlocksForThisClass,
						[b.id, "isReleased"],
						true
					),
					isLocked,
					disabledText,
					displayName: b.displayName,
					onClick: isLocked
						? _.noop
						: () => {
								this.changeBlockAssignment(
									b.id,
									isAssigned ? "un-assign" : "assign"
								);
						  },
				};
			});
			return assignedBlockData;
		},

		changeBlockAssignment: function(blockID, changeType) {
			const {classID} = this.props;
			this.props.dispatch({
				type: AT.ASSIGN_BLOCK_FOR_CLASS_REQUEST,
				blockID,
				classID,
				changeType,
			});
		},

		makeTableHeader: function() {
			const {
				gradeNumber,
				chapterNumber,
				typeID,
				labBlockID,
				blocksObj,
				blockNumber,
				bookTest,
				labBlocksObj,
				lockOverrides,
				classID,
				classesData,
				schoolState,
				assignedBlocksObj,
			} = this.props;
			const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
			const {toggleAssigned} = this.state;
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			const blockData = _.get(blocksObj, [chapterID, "blocks"]);
			const testBlock = _.get(blocksObj, [chapterID, "testBlock"]);
			let assignedBlockData = [];

			if (blockData) {
				assignedBlockData = this.getAssignedBlockData({
					assignedBlocksObj,
					classID,
					blockData:
						blockData && testBlock ? _.concat(blockData, testBlock) : blockData,
					isAcademy,
				});
			} else if (gradeNumber) {
				assignedBlockData = this.getAssignedBlockDataForChapters({
					assignedBlocksObj,
					classID,
					gradeNumber,
					isAcademy,
				});
			} else {
				assignedBlockData = this.getAssignedBlockDataForGrades({
					assignedBlocksObj,
					classID,
					isAcademy,
				});
			}

			let labBlockData = _.get(labBlocksObj, [typeID, "blocks"]);
			labBlockData = _.filter(labBlockData, b => !b.underConstruction);

			let scope = "grades";
			if (labBlockID) scope = "labBlock";
			else if (typeID) scope = "labType";
			else if (blockNumber || bookTest) scope = "problems";
			else if (chapterNumber) scope = "blocks";
			else if (gradeNumber) {
				scope = gradeNumber === "lab" ? "lab" : "chapters";
			}

			const classIsActive = _.get(classesData, [classID, "activeAndCurrent"]);

			const lockDisabledText = classIsActive
				? undefined
				: "This class is not active, so its locks have no effect.";
			const lockDisabledForAssignedBlockText =
				"This lesson is assigned. You must un-assign it before locking it.";

			let graphHeading, assignedToggle;
			if (typeID) {
				const blockIDs = _.map(labBlockData, b => b.id);
				const labels = ClassesUtil.getLabBlockLabels(labBlockData);
				const labBlockLabels = labBlockData.map((bd, i) => (
					<HoverText
						text={bd.displayName}
						key={"block" + bd.id}
						size="medium"
						direction="br"
					>
						<Link
							to={URLMake.forClassReport(classID, {
								grade: "lab",
								typeID,
								labBlockID: bd.id,
							})}
							className={styles.link}
						>
							{labels[i]}
						</Link>
					</HoverText>
				));
				const headingLockOverrides = isAcademy
					? null
					: {
							lockOverrides,
							objectType: "labBlock",
							objectIDs: blockIDs,
							disabledText: lockDisabledText,
							onLockUpdate: this.props.dispatch,
					  };

				graphHeading = (
					<GraphTableHeading
						isAcademy={isAcademy}
						className={styles.graphHeader}
						colClass={styles.headerColSmall}
						labels={labBlockLabels}
						lockOverridesInfo={headingLockOverrides}
						assignedBlocks={assignedBlockData}
						testBlock={testBlock}
						classID={classID}
					/>
				);
			} else if (chapterNumber) {
				const blockIDs = _.map(blockData, b => b.id);

				const blockLabels = _.range(1, blockData.length + 1).map(i => (
					<HoverText
						text={_.get(blockData, [i - 1, "displayName"])}
						key={"block" + i}
						size="medium"
						direction="br"
					>
						<Link
							to={URLMake.forClassReport(classID, {
								grade: gradeNumber,
								chapter: chapterNumber,
								block: i,
							})}
							className={styles.link}
						>
							{i}
						</Link>
					</HoverText>
				));
				blockLabels.push(
					<HoverText
						text={_.get(testBlock, "displayName")}
						key={"blocktest"}
						size="medium"
						direction="br"
					>
						<Link
							to={URLMake.forClassReport(classID, {
								grade: gradeNumber,
								chapter: chapterNumber,
								block: "test",
							})}
							className={styles.link}
						>
							{"Test"}
						</Link>
					</HoverText>
				);
				const trophiesAvailable = _.map(blockData, bd => !!bd.trophySetListID);
				const headingLockOverrides = isAcademy
					? null
					: {
							lockOverrides,
							objectType: "block",
							objectIDs: blockIDs.concat([testBlock.id]),
							disabledText: lockDisabledText,
							disabledForAssignedBlockText: lockDisabledForAssignedBlockText,
							onLockUpdate: this.props.dispatch,
					  };

				graphHeading = (
					<GraphTableHeading
						isAcademy={isAcademy}
						className={styles.graphHeader}
						colClass={styles.headerColSmall}
						labels={blockLabels}
						lockOverridesInfo={headingLockOverrides}
						trophiesAvailable={trophiesAvailable}
						assignedBlocks={assignedBlockData}
						testBlock={testBlock}
						classID={classID}
						toggleAssigned={toggleAssigned}
					/>
				);

				const hasAssignments = _.some(assignedBlockData, b => b.isAssigned);

				assignedToggle = (
					<AssignedToggle
						onToggle={s => this.setState({toggleAssigned: s})}
						isToggleOn={toggleAssigned}
						disabled={!hasAssignments}
						isAcademy={isAcademy}
					/>
				);
			} else if (_.isInteger(gradeNumber)) {
				const chapterIDs = GradeChapter.getAllChaptersForGrade(gradeNumber);
				const chapterLabels = _.range(1, chapterIDs.length + 1).map(i => (
					<HoverText
						text={GradeChapter.getChapterName(gradeNumber, i)}
						key={"block" + i}
						size="medium"
						direction="br"
					>
						<Link
							to={URLMake.forClassReport(classID, {
								grade: gradeNumber,
								chapter: i,
							})}
							key={"chapter" + i}
							className={styles.link}
						>
							{i}
						</Link>
					</HoverText>
				));
				const headingLockOverrides = isAcademy
					? null
					: {
							lockOverrides,
							objectType: "chapter",
							objectIDs: chapterIDs,
							disabledText: lockDisabledText,
							onLockUpdate: this.props.dispatch,
					  };

				graphHeading = (
					<GraphTableHeading
						isAcademy={isAcademy}
						className={styles.graphHeader}
						colClass={styles.headerColFlex}
						labels={chapterLabels}
						lockOverridesInfo={headingLockOverrides}
						assignedBlocks={assignedBlockData}
						testBlock={testBlock}
						classID={classID}
					/>
				);
			} else if (gradeNumber === "lab") {
				const typeIDs = OpsLab.getAllTypeIDs();
				const typeLabels = typeIDs.map(tid => {
					const typeName = OpsLab.getTypeNameFromID(tid);
					const typeAbbr = StringUtil.getAcronym(typeName);
					return (
						<HoverText
							text={typeName}
							key={"type" + tid}
							size="medium"
							direction="br"
						>
							<Link
								to={URLMake.forClassReport(classID, {
									grade: "lab",
									typeID: tid,
								})}
								className={styles.link}
							>
								{typeAbbr}
							</Link>
						</HoverText>
					);
				});
				const headingLockOverrides = isAcademy
					? null
					: {
							lockOverrides,
							objectType: "labType",
							objectIDs: typeIDs,
							disabledText: lockDisabledText,
							onLockUpdate: this.props.dispatch,
					  };

				graphHeading = (
					<GraphTableHeading
						isAcademy={isAcademy}
						className={styles.graphHeader}
						colClass={styles.headerColFlex}
						labels={typeLabels}
						lockOverridesInfo={headingLockOverrides}
						assignedBlocks={assignedBlockData}
						testBlock={testBlock}
						classID={classID}
					/>
				);
			} else {
				const gradeIDs = GradeChapter.getActiveGrades().concat(["lab"]);
				const labelMap = {lab: "Puzzle Lab"};
				const gradeLabels = gradeIDs.map(i => (
					<Link
						to={URLMake.forClassReport(classID, {grade: i})}
						key={"grade" + i}
						className={styles.link}
					>
						{labelMap[i] || i}
					</Link>
				));
				const headingLockOverrides = isAcademy
					? null
					: {
							lockOverrides,
							objectType: "grade",
							objectIDs: gradeIDs,
							disabledText: lockDisabledText,
							onLockUpdate: this.props.dispatch,
					  };
				graphHeading = (
					<GraphTableHeading
						isAcademy={isAcademy}
						className={styles.graphHeader}
						colClass={styles.headerColLarge}
						labels={gradeLabels}
						lockOverridesInfo={headingLockOverrides}
						assignedBlocks={assignedBlockData}
						testBlock={testBlock}
						classID={classID}
					/>
				);
			}

			return Helpers.getHeader(scope, {
				blockData,
				graphHeading,
				blockNumber,
				assignedToggle,
				forClass: true,
				forTest: !!bookTest || blockNumber === "test",
				forBookTest: !!bookTest,
			});
		},

		makeTableData: function() {
			const {
				gradeNumber,
				chapterNumber,
				bookTest,
				blockNumber,
				typeID,
				labBlockID,
			} = this.props;
			if (labBlockID) {
				return this.makeLabProblemData();
			} else if (typeID) {
				return this.makeLabBlockData();
			} else if (bookTest || blockNumber) {
				return this.makeProblemData();
			} else if (chapterNumber) {
				return this.makeBlockData();
			} else if (gradeNumber) {
				if (gradeNumber === "lab") {
					return this.makeLabTypeData();
				} else {
					return this.makeChapterData();
				}
			} else {
				return this.makeGradeData();
			}
		},

		makeGradeData: function() {
			const {
				studentIDs,
				classGradeChapter,
				classLabTypes,
				labBlocksObj,
			} = this.props;
			const activeGrades = GradeChapter.getActiveGrades();
			const numGrades = activeGrades.length;

			const summaryStarData = _.fill(Array(numGrades), []);
			summaryStarData.push([]); // This one is for puzzle lab
			let classStars = 0;
			let classTrophies = 0;
			let classProblemsCorrect = 0;
			let classTime = 0;
			const dataTypes = _.fill(Array(numGrades), "stars");
			dataTypes.push("celestials");
			const rows = studentIDs.map(sid => {
				const trainerData = classGradeChapter[sid];
				const labData = classLabTypes[sid];
				const {user, stars} = trainerData;
				const {celestials} = labData;
				const totalStarData = _.flatMap(_.values(stars));
				const gradeStars = activeGrades.map((g, i) => {
					const gs = this.getStarDataForGrade(stars, g);
					summaryStarData[i] = _.concat(summaryStarData[i], gs);
					return (
						<StarBar
							key={"grade" + g}
							barData={gs}
							className={styles.graphBarFat}
							isVertical={true}
						/>
					);
				});
				// Need to filter out celestials from under construction lab blocks
				const filteredCD = {};
				_.each(celestials, (arr, tid) => {
					filteredCD[tid] = ClassesUtil.filterCelestials(
						arr,
						labBlocksObj[tid]
					);
				});
				const adjustedCelestials = _.flatMap(filteredCD, c =>
					c > 0 ? c - 1 : c
				);
				summaryStarData[numGrades] = _.concat(
					summaryStarData[numGrades],
					adjustedCelestials
				);
				gradeStars.push(
					<StarBar
						key={"lab"}
						className={styles.graphBarFat}
						colorScheme="lab"
						barData={adjustedCelestials}
						isVertical={true}
					/>
				);

				const usd = user.studentData || {};
				classStars += usd.stars || 0;
				classTrophies += usd.trophies || 0;
				classProblemsCorrect += usd.problemsCorrect;
				// We're taking trainer and lab data here
				const trainerSeconds = _.get(usd, "totalTimeData.trainer", 0);
				const labSeconds = _.get(usd, "totalTimeData.lab", 0);
				const seconds = trainerSeconds + labSeconds;
				classTime += seconds;

				const userDate = ClassesUtil.getUserDate(
					usd.lastPlayed,
					usd.lastPlayedTZ
				);

				return {
					name: (
						<Link
							to={URLMake.forStudentReport(usd.userID)}
							className={styles.link}
						>
							{ClassesUtil.getStudentName(user)}
						</Link>
					),
					nameValue: ClassesUtil.getStudentName(user),
					summary: (
						<StarBar barData={totalStarData} className={styles.summaryBar} />
					),
					grades: (
						<div className={styles.graphOuter + " " + styles.allLevels}>
							{gradeStars}
						</div>
					),
					played:
						userDate === "-" ? (
							userDate
						) : (
							<Link
								to={URLMake.forStudentReport(usd.userID, {
									...this.props.pageData,
									date: ClassesUtil.getSortableDate(userDate),
									type: "activity",
								})}
								className={styles.link}
							>
								{userDate}
							</Link>
						),
					playedValue: userDate,
					star: usd.stars || 0,
					trophy: usd.trophies || 0,
					pc: usd.problemsCorrect || 0,
					time:
						ProfileUtil.getDurationVeryShortString(parseFloat(seconds / 60)) ||
						"0m",
				};
			});
			// Add the summary row
			rows.unshift({
				name: "Summary",
				grades: (
					<SummaryCircles
						className={styles.circlesOuter}
						circleClass={styles.circleWrapLarge}
						data={summaryStarData}
						dataTypes={dataTypes}
					/>
				),
				star: classStars,
				trophy: classTrophies,
				pc: classProblemsCorrect,
				time:
					ProfileUtil.getDurationVeryShortString(
						parseFloat(Math.floor(classTime) / 60)
					) || "0m",
			});

			return rows;
		},

		makeLabTypeData: function() {
			const {studentIDs, classLabTypes, labBlocksObj} = this.props;
			const typeIDs = OpsLab.getAllTypeIDs();
			const summaryCelestials = _.fill(Array(typeIDs.length), []);
			let classProblemsCorrect = 0;
			let classTime = 0;

			const rows = studentIDs.map(sid => {
				const s = classLabTypes[sid];
				const {user, celestials, byType, labSpace} = s;
				let celestialData = [];
				_.each(typeIDs, (tid, i) => {
					// Need to filter out under construction blocks
					const cd = ClassesUtil.filterCelestials(
						celestials[tid],
						labBlocksObj[tid]
					);
					const adjCD = cd.map(c => (c > 0 ? c - 1 : c));
					celestialData = _.concat(celestialData, adjCD);
					summaryCelestials[i] = summaryCelestials[i].concat(adjCD);
					const typeData = byType[tid] || {};
					classProblemsCorrect += typeData.problemsCorrect || 0;
					const minutes = parseFloat(typeData.timeSpent || 0) / 60;
					classTime += minutes;
				});

				const displayName = (
					<Link
						to={URLMake.forStudentReport(user.studentData.userID, {
							grade: "lab",
						})}
						className={styles.link}
					>
						{ClassesUtil.getStudentName(user)}
					</Link>
				);
				const nameValue = ClassesUtil.getStudentName(user);
				const summary = (
					<StarBar
						barData={celestialData}
						className={styles.summaryBar}
						colorScheme="lab"
					/>
				);

				return Helpers.getLabTypeBody({
					celestials,
					displayName,
					nameValue,
					pageData: {grade: "lab"},
					summary,
					spaceData: labSpace || {},
					studentID: user.studentData.userID,
					labBlocksObj,
					typeIDs,
					forClass: true,
				});
			});
			const celestialCounts = ClassesUtil.getCelestialStats(
				_.flatMap(summaryCelestials, c => c)
			);
			// Add the summary row
			rows.unshift({
				name: "Summary",
				summary: null,
				labTypes: (
					<SummaryCircles
						className={styles.circlesOuter}
						circleClass={styles.circleWrap}
						data={summaryCelestials}
						dataType="celestials"
					/>
				),
				played: null,
				pc: classProblemsCorrect,
				time: ProfileUtil.getDurationVeryShortString(classTime),
				...celestialCounts,
			});

			return rows;
		},

		makeChapterData: function() {
			const students = this.props.studentIDs.map(
				sid => this.props.classGradeChapter[sid]
			);
			const gradeID = this.props.gradeNumber;

			const chapterIDs = GradeChapter.getAllChaptersForGrade(gradeID);
			const summaryStarData = _.fill(Array(chapterIDs.length), []);

			let classStars = 0;
			let classTrophies = 0;
			let classProblemsCorrect = 0;
			let classTime = 0;
			const rows = students.map(s => {
				const {user, byGrade, stars} = s;

				const starData = this.getStarDataForGrade(stars, gradeID);
				const chapStars = _.fill(Array(chapterIDs.length), null);
				_.each(stars, (st, cid) => {
					if (_.includes(chapterIDs, parseInt(cid))) {
						const context = GradeChapter.chapterIDToContext(cid);
						chapStars[context.chapterIndex] = st;
						summaryStarData[context.chapterIndex] = summaryStarData[
							context.chapterIndex
						].concat(st);
					}
				});

				const gradeData = _.get(byGrade, [gradeID]) || {};
				classStars += gradeData.stars || 0;
				classTrophies += gradeData.trophies || 0;
				classProblemsCorrect += gradeData.problemsCorrect || 0;
				const minutes = parseFloat(gradeData.timeSpent || 0) / 60;
				classTime += minutes;

				const displayName = (
					<Link
						to={URLMake.forStudentReport(user.studentData.userID, {
							grade: gradeID,
						})}
						className={styles.link}
					>
						{ClassesUtil.getStudentName(user)}
					</Link>
				);
				const nameValue = ClassesUtil.getStudentName(user);
				const summary = (
					<StarBar barData={starData} className={styles.summaryBar} />
				);

				return Helpers.getChapterBody({
					gradeData,
					stars: chapStars,
					displayName,
					nameValue,
					pageData: {grade: gradeID},
					summary,
					studentID: user.studentData.userID,
					forClass: true,
				});
			});
			// Add the summary row
			rows.unshift({
				name: "Summary",
				summary: null,
				chapters: (
					<SummaryCircles
						className={styles.circlesOuter}
						circleClass={styles.circleWrap}
						data={summaryStarData}
						dataType="stars"
					/>
				),
				played: null,
				star: classStars,
				trophy: classTrophies,
				pc: classProblemsCorrect,
				time: ProfileUtil.getDurationVeryShortString(classTime) || "0m",
			});

			return rows;
		},

		makeLabBlockData: function() {
			const {
				classLabBlockResults,
				labBlocksObj,
				typeID,
				studentIDs,
				pageData,
			} = this.props;
			let blocks = _.get(labBlocksObj, [typeID, "blocks"]);
			blocks = _.filter(blocks, b => !b.underConstruction);

			const summaryCelestials = _.fill(Array(blocks.length), []);
			let classProblemsCorrect = 0;
			let classTime = 0;
			const rows = studentIDs.map(sid => {
				const s = classLabBlockResults[sid] || {};
				const {user, byBlockID = {}, last = {}, typeTotals = {}} = s;
				const lastData = last[typeID] || {};

				// Takes celestials in the form {1: 2, 2: 3} => [1, 1, 2, 2, 2]
				let celestialData = _.flatMap(typeTotals.celestials || [], (cc, cid) =>
					_.fill(Array(cc), parseInt(cid) - 1)
				);
				// Extend it to the length of all blocks, default -1 for undone
				celestialData = ArrayUtil.extendArray(celestialData, blocks.length, -1);

				classProblemsCorrect += typeTotals.problemsCorrect || 0;
				const minutes = parseFloat(typeTotals.timeSpent || 0) / 60;
				classTime += minutes;
				_.each(blocks, (bl, i) => {
					const earned = _.get(byBlockID, [bl.id, "celestialEarned"]);
					summaryCelestials[i] = summaryCelestials[i].concat([
						earned ? bl.celestialID - 1 : -1,
					]);
					if (!_.get(byBlockID, bl.id))
						byBlockID[bl.id] = {celestialID: bl.celestialID};
				});
				const nameValue = ClassesUtil.getStudentName(user);
				const summary = (
					<StarBar
						barData={celestialData}
						className={styles.summaryBar}
						colorScheme="lab"
					/>
				);

				const displayName = (
					<Link
						to={URLMake.forStudentReport(user.studentData.userID, {
							grade: "lab",
							typeID,
						})}
						className={styles.link}
					>
						{ClassesUtil.getStudentName(user)}
					</Link>
				);
				return Helpers.getLabBlockBody({
					labBlocksObj,
					displayName,
					nameValue,
					typeID,
					studentID: user.studentData.userID,
					summary,
					last: lastData,
					byLabBlockID: byBlockID,
					pageData,
					celestials: celestialData,
					typeTotals,
					forClass: true,
				});
			});
			const celestialCounts = ClassesUtil.getCelestialStats(
				_.flatMap(summaryCelestials, c => c)
			);

			// Add the summary row
			rows.unshift({
				name: "Summary",
				summary: null,
				labBlocks: (
					<SummaryCircles
						className={styles.circlesOuter}
						data={summaryCelestials}
						dataType="celestials"
					/>
				),
				played: null,
				pc: classProblemsCorrect,
				time: ProfileUtil.getDurationVeryShortString(classTime),
				...celestialCounts,
			});

			return rows;
		},

		makeBlockData: function() {
			const {
				classChapterBlock,
				blocksObj,
				gradeNumber,
				chapterNumber,
				studentIDs,
				classID,
				assignedBlocksObj,
			} = this.props;
			const {toggleAssigned} = this.state;
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			const students = studentIDs.map(sid => classChapterBlock[sid]);
			const blocks = _.get(blocksObj, [chapterID, "blocks"]);
			const testBlock = _.get(blocksObj, [chapterID, "testBlock"]);

			let classStars = 0;
			let classTrophies = 0;
			let classProblemsCorrect = 0;
			let classTime = 0;
			let blocksToUse = blocks.concat([testBlock]);
			if (toggleAssigned) {
				blocksToUse = _.filter(
					blocksToUse,
					b => !!_.get(assignedBlocksObj, [classID, b.id, "isAssigned"])
				);
			}
			const summaryStarData = _.fill(Array(blocksToUse.length), []);
			const rows = students.map(s => {
				const {user, byBlockID} = s;

				const starData = _.map(blocksToUse, (b, i) => {
					const starOnBlock = ClassesUtil.getStarsFromBlock(
						byBlockID[b.id],
						true
					).stars;
					summaryStarData[i] = summaryStarData[i].concat([starOnBlock]);
					// Exclude intervened and partial complete (-2, -3)
					return Math.max(-1, starOnBlock);
				});

				const chapterTotals = s.chapterTotals || {};

				classStars += chapterTotals.stars || 0;
				classTrophies += chapterTotals.trophies || 0;
				classProblemsCorrect += chapterTotals.problemsCorrect || 0;
				const minutes = parseFloat(chapterTotals.timeSpent || 0) / 60;
				classTime += minutes;

				const nameValue = ClassesUtil.getStudentName(user);
				const summary = (
					<StarBar barData={starData} className={styles.summaryBar} />
				);

				const displayName = (
					<Link
						to={URLMake.forStudentReport(user.studentData.userID, {
							grade: gradeNumber,
							chapter: chapterNumber,
						})}
						className={styles.link}
					>
						{ClassesUtil.getStudentName(user)}
					</Link>
				);
				return Helpers.getBlockBody({
					chapterTotals,
					blocksObj,
					displayName,
					nameValue,
					pageData: {gradeNumber, chapterNumber},
					studentID: user.studentData.userID,
					summary,
					byBlockID,
					chapterID,
					forClass: true,
					toggleAssigned,
					assignedBlocks: _.get(assignedBlocksObj, [classID], {}),
				});
			});

			// Add the summary row
			rows.unshift({
				name: "Summary",
				summary: null,
				blocks: (
					<SummaryCircles
						className={styles.circlesOuter}
						data={summaryStarData}
						dataType="stars-intervened"
					/>
				),
				played: null,
				trophy: classTrophies,
				star: classStars,
				pc: classProblemsCorrect,
				time: ProfileUtil.getDurationVeryShortString(classTime) || "0m",
			});

			return rows;
		},

		makeLabProblemData: function() {
			const {
				classLabBlockResults,
				labBlocksObj,
				typeID,
				labBlockID,
				studentIDs,
				pageData,
			} = this.props;
			const blocks = _.get(labBlocksObj, [typeID, "blocks"]);
			const block = _.find(blocks, b => b.id === parseInt(labBlockID));

			let classProblemsCorrect = 0;
			let classTime = 0;
			const studentBlockData = [];
			const rows = studentIDs.map(sid => {
				const s = _.get(classLabBlockResults, [sid]);
				const {user, byBlockID} = s || {};
				const bd = byBlockID[labBlockID] || {userID: sid, blockID: block.id};
				studentBlockData.push(bd);
				const displayName = (
					<Link
						to={URLMake.forStudentReport(sid, {
							grade: "lab",
							typeID,
						})}
						className={styles.link}
					>
						{ClassesUtil.getStudentName(user)}
					</Link>
				);
				const nameValue = ClassesUtil.getStudentName(user);
				const key = block.id;

				const pc = bd.problemsCorrect || 0;
				classProblemsCorrect += pc;
				const minutes = parseFloat(bd.timeSpent || 0) / 60;
				classTime += minutes;

				return Helpers.getLabProblemBody({
					bd,
					displayName,
					nameValue,
					key,
					setList: block.setList,
					celestialID: block.celestialID,
					pageData,
					studentID: user.studentData.userID,
					onClick: this.openResult,
					forClass: true,
				});
			});

			// Add the summary row
			const summaryRow = {
				name: "Summary",
				latest: (
					<SummaryCircles
						className={styles.problemsOuter}
						data={ClassesUtil.getStudentProblems(studentBlockData)}
						dataType="trials"
						problemsPerSet={block.setList.problemsPerSet}
					/>
				),
				time: ProfileUtil.getDurationShortString(classTime),
			};
			summaryRow.pc = classProblemsCorrect;

			rows.unshift(summaryRow);

			return rows;
		},

		makeProblemData: function() {
			const {
				classBlockResults,
				classBookTestResults,
				blocksObj,
				bookTestBlocksObj,
				gradeNumber,
				chapterNumber,
				blockNumber,
				bookTest,
				studentIDs,
				pageData,
			} = this.props;

			const forBookTest = !!bookTest;
			const forTest = forBookTest || blockNumber === "test";
			const chapterID = bookTest
				? null
				: GradeChapter.toChapterID(gradeNumber, chapterNumber - 1);

			let block;
			let blockKey = blockNumber;
			if (bookTest) {
				blockKey = "bookTest" + bookTest;
				block = _.get(bookTestBlocksObj, [blockKey]);
			} else if (blockNumber === "test") {
				block = _.get(blocksObj, [chapterID, "testBlock"]);
			} else {
				const blocks = _.get(blocksObj, [chapterID, "blocks"]);
				block = blocks[parseInt(blockNumber) - 1];
			}
			const setList = block.setList;
			const rm = ResultManager(setList);
			const skipProblemCount = rm.skipProblemCount;
			const hasTrophy = block.trophySetListID;
			const studentBlockData = [];

			const linkPageData = bookTest
				? {
						grade: gradeNumber,
						bookTest,
				  }
				: {
						grade: gradeNumber,
						chapter: chapterNumber,
						block: blockNumber,
				  };

			let classProblemsCorrect = 0;
			let classTime = 0;
			const rows = studentIDs.map(sid => {
				const s = bookTest ? classBookTestResults[sid] : classBlockResults[sid];
				const {user, byBlockNumber} = s;
				const userID = user.studentData.userID;
				let bd = byBlockNumber[blockKey] || {userID, blockID: block.id};
				bd = _.extend(bd, {requirementLevel: block.requirementLevel});
				studentBlockData.push(bd);
				const displayName = (
					<Link
						to={URLMake.forStudentReport(user.studentData.userID, linkPageData)}
						className={styles.link}
					>
						{ClassesUtil.getStudentName(user)}
					</Link>
				);
				const nameValue = ClassesUtil.getStudentName(user);
				const key = blockNumber - 1;

				let pc = 0;
				if (!skipProblemCount) {
					if (bd.hasOwnProperty("stars")) {
						pc = bd.problemsCorrect;
						classProblemsCorrect += pc;
					}
				}
				const minutes = ClassesUtil.getResultMinutesSpent(bd, {forBookTest});
				classTime += minutes;

				return Helpers.getProblemBody({
					bd,
					displayName,
					nameValue,
					setList,
					skipProblemCount,
					key,
					pageData,
					hasTrophy,
					studentID: user.studentData.userID,
					onClick: this.openResult,
					forClass: true,
					forTest,
					forBookTest,
				});
			});

			// Add the summary row
			const summaryRow = {
				name: "Summary",
				latest:
					rm && rm.skipProblemCount ? (
						<div className={styles.problemsOuter} />
					) : (
						<SummaryCircles
							className={styles.problemsOuter}
							data={ClassesUtil.getStudentProblems(studentBlockData)}
							dataType="trials"
							problemsPerSet={setList.problemsPerSet}
							forTest={forTest}
							forBookTest={forBookTest}
						/>
					),
				time: ProfileUtil.getDurationShortString(classTime),
			};
			if (!skipProblemCount) {
				summaryRow.pc = classProblemsCorrect;
			} else {
				summaryRow.pc = "-";
			}

			rows.unshift(summaryRow);

			return rows;
		},

		getStarDataForGrade: function(starData, gradeID) {
			const chapterIDs = GradeChapter.getAllChaptersForGrade(gradeID);
			const gradeStars = _.filter(starData, (s, cid) =>
				_.includes(chapterIDs, parseInt(cid))
			);
			return _.concat(...gradeStars);
		},

		renderTestUnlockPanel: function() {
			const {bookTest, classesData, classID} = this.props;

			const testBlockInfo = _.get(classesData, [classID, "testBlockInfo"], []);
			const thisTestBlock = _.find(
				testBlockInfo,
				r => r.miscBlockName === "bookTest" + bookTest
			);
			if (!thisTestBlock) return null;

			// TODO: parameterize startResolution?
			return (
				<div className={styles.testUnlockRow}>
					<ReportTestUnlockPanel
						startsAt={thisTestBlock.testStartsAt}
						startResolution="1 minute"
						unlocked={thisTestBlock.unlocked}
						onUnlock={() => this.onUnlockBookTest()}
					/>
				</div>
			);
		},

		renderBody: function() {
			const {
				gradeNumber,
				chapterNumber,
				blockNumber,
				bookTest,
				classID,
				containerDims,
				forPrint,
			} = this.props;
			const w = containerDims.windowWidth;
			const hiddenColumns = [];
			// Hide different columns for different grades because # blocks won't fit
			if (w < 1160 || (gradeNumber > 3 && w < 1400)) {
				hiddenColumns.push("summary");
			}
			if (w < 1120 || (gradeNumber > 3 && w < 1320)) {
				hiddenColumns.push("played");
			}
			let viewType = null;
			if (blockNumber || bookTest) viewType = "problem";
			const renderLoaded = () => {
				return (
					<ReportTable
						headers={this.makeTableHeader()}
						data={this.makeTableData()}
						viewType={viewType}
						isClass={true}
						hideColumns={hiddenColumns}
						forPrint={forPrint}
						forBookTest={!!bookTest}
					/>
				);
			};
			const chapterLG = {
				identifier: `reportClassGradeChapter-${classID}`,
				status: this.props.classGradeChapterLoad,
				requestLoad: this.loadGradeChapter,
			};
			const chapterBlocksLG = {
				identifier:
					`reportClassChapterBlocks-${classID}-` +
					`${gradeNumber || 0}-${chapterNumber || 0}`,
				status: this.props.classChapterBlockLoad,
				requestLoad: this.loadChapterBlock,
			};
			const blockResultsLG = {
				identifier:
					`reportClassBlockResults-${classID}-` +
					`${gradeNumber || 0}-${chapterNumber || 0}-${blockNumber || 0}`,
				status: this.props.classBlockResultsLoad,
				requestLoad: this.loadBlockResults,
			};
			const bookTestResultsLG = {
				identifier:
					`reportClassBookTestResults-${classID}-` + `${bookTest || ""}`,
				status: this.props.classBookTestResultsLoad,
				requestLoad: this.loadBookTestResults,
			};
			const blockLG = {
				identifier:
					`blocks-${classID}-` +
					`${gradeNumber || 0}-${chapterNumber || 0}-${blockNumber || 0}`,
				status: this.props.blocksObjLoad,
				requestLoad: this.loadBlocks,
			};
			const assignedBlocksLG = {
				identifier: `assignedBlocks-${classID}`,
				status: this.props.assignedBlocksObjLoad,
				requestLoad: this.loadAssignedBlocks,
			};

			const typesLG = {
				identifier: "reportClassLabTypes" + classID,
				status: this.props.classLabTypesLoad,
				requestLoad: this.loadLabTypes,
			};

			const lockLG = {
				identifier: "trainerLockOverrides-" + classID,
				status: this.props.lockOverrides,
				requestLoad: this.loadLockOverrides,
			};

			let guards = [];
			if (bookTest) {
				guards = [bookTestResultsLG];
			} else if (blockNumber || chapterNumber) {
				guards = [blockLG, blockNumber ? blockResultsLG : chapterBlocksLG];
			} else {
				guards = [chapterLG];
				if (!gradeNumber) {
					guards.push(typesLG);
				}
			}
			if (classID) {
				guards.push(assignedBlocksLG);
			}
			guards.push(lockLG);
			return (
				<div className={styles.main}>
					<MultiLoadGuard
						guardList={guards}
						loadingView="logo"
						logoColorType="color"
						loadingViewClass={styles.loading}
						errorView="refreshOffice"
						renderLoaded={renderLoaded}
					/>
				</div>
			);
		},

		renderPuzzle: function() {
			const {gradeNumber, typeID, labBlockID, classID, forPrint} = this.props;
			// Set up all the load guards we might need and the final render.
			let viewType = "lab";
			if (labBlockID) viewType = "labBlock";
			else if (typeID) viewType = "labType";
			const renderLoadedFinal = () => {
				return (
					<ReportTable
						headers={this.makeTableHeader()}
						data={this.makeTableData()}
						forPrint={forPrint}
						viewType={viewType}
						isClass={true}
					/>
				);
			};
			const typesLG = {
				identifier: "reportClassLabTypes" + classID,
				status: this.props.classLabTypesLoad,
				requestLoad: this.loadLabTypes,
			};
			const blockResultsLG = {
				identifier:
					`reportClassLabBlockResults-` +
					classID +
					"-" +
					(typeID || 0) +
					"-" +
					(labBlockID || 0),
				status: this.props.classLabBlockResultsLoad,
				requestLoad: this.loadLabBlockResults,
			};
			const blockLG = {
				identifier:
					`classLabTypeBlocks-` +
					classID +
					"-" +
					(typeID || 0) +
					"-" +
					(labBlockID || 0),
				status: this.props.labBlocksObjLoad,
				requestLoad: this.loadLabBlocks,
			};
			const lockLG = {
				identifier: "lockOverrides-" + classID,
				status: this.props.lockOverrides,
				requestLoad: this.loadLockOverrides,
			};

			// Which load guards do we need?
			let guards = [];
			if (typeID || labBlockID) {
				guards = [blockLG, blockResultsLG];
			} else if (gradeNumber === "lab") {
				guards = [blockLG, typesLG];
			} else {
				guards = [typesLG];
			}
			guards.push(lockLG);

			return (
				<div className={styles.main}>
					<MultiLoadGuard
						guardList={guards}
						loadingView="logo"
						logoColorType="color"
						loadingViewClass={styles.loading}
						errorView="refreshOffice"
						renderLoaded={renderLoadedFinal}
					/>
				</div>
			);
		},

		render: function() {
			const {
				pageData,
				classID,
				gradeNumber,
				chapterNumber,
				bookTest,
				blockNumber,
				typeID,
				labBlockID,
				blocksObj,
				labBlocksObj,
				user,
				schoolState,
				lockOverrides,
				dispatch,
				forPrint,
			} = this.props;
			const filters = {
				grade: gradeNumber,
				chapter: chapterNumber || typeID,
				block: blockNumber || labBlockID,
			};
			if (bookTest) {
				filters.chapter = "bookTest" + bookTest;
			}
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			const blockData = _.get(blocksObj, [chapterID, "blocks"]);
			let labBlockData = _.get(labBlocksObj, [typeID, "blocks"]);
			labBlockData = _.filter(labBlockData, b => !b.underConstruction);

			const trainerSpace =
				!gradeNumber || gradeNumber !== "lab" ? this.renderBody() : null;
			const puzzleSpace = gradeNumber === "lab" ? this.renderPuzzle() : null;

			const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
			const testUnlockPanel = bookTest ? this.renderTestUnlockPanel() : null;

			const bookTestHashes = ClassesUtil.getBookTestHashesForClass(
				this.props.classesData,
				classID
			);

			const reportNavHeader = forPrint ? null : (
				<div className={styles.navRow}>
					<ReportNavigationHeader
						assignedBlocksObj={this.props.assignedBlocksObj[classID] || {}}
						pageData={pageData}
						blocksObj={blocksObj}
						labBlocksObj={labBlocksObj}
						lockOverrides={lockOverrides}
						dispatch={dispatch}
						forParent={false}
						isAcademy={isAcademy}
					/>
				</div>
			);

			const {showAssignedBlocksModal = {}} = this.props;

			let assignedBlocksModal = null;

			if (showAssignedBlocksModal.show) {
				const students = _.get(
					this.props.schoolState,
					["accounts", "students"],
					{}
				);
				const {
					studentIDs,
					blockID,
					errorType,
					changeType,
				} = showAssignedBlocksModal;
				const {blocksObjLoad} = this.props;
				const blockInfo =
					blocksObjLoad && blocksObjLoad.load === "done"
						? _.find(blocksObj[chapterID].blocks, b => b.id === blockID)
						: {};
				const studentList = studentIDs.map(sid => students[sid]);
				assignedBlocksModal = (
					<OfficeModal
						onClose={this.dismissAssignedBlockModal}
						level={"warning"}
						portalContainer={PORTAL_CONTAINERS.ASSIGNED_BLOCKS_MODAL}
						closeOnEsc={true}
						closeOnBackdropClick={false}
						modalClass={styles.modal}
						backdropClass={styles.backdrop}
					>
						{CopyTable.getAssignedBlocksModalCopy(
							errorType,
							changeType,
							blockInfo,
							studentList,
							styles
						)}
					</OfficeModal>
				);
			}

			// These are the filters for an individual class
			return (
				<div className={styles.main}>
					<div className={styles.crumbRow}>
						<ReportCrumbs
							user={user}
							pageData={pageData}
							filters={filters}
							updateFilter={this.filterBy}
							bookTestHashes={bookTestHashes}
							blockData={blockData}
							labBlockData={labBlockData}
						/>
						<Link
							className={styles.printIcon}
							to={"/print" + URLMake.forClassReport(classID, pageData)}
							isNewTab={true}
						>
							:
						</Link>
					</div>
					{reportNavHeader}
					{assignedBlocksModal}
					{testUnlockPanel}
					{trainerSpace}
					{puzzleSpace}
				</div>
			);
		},
	})
);
